export enum HeroEventListColumnsEnum {
  EVENT_ID = 'Event Id',
  EVENT_NAME = 'Event Name',
  EVENT_CATEGORY = 'Event Category',
  RECURRENCE = 'Recurrence',
  NEXT_EVENT = 'Next Event',
  ACTIVE = 'Active',
  ACTION = 'Actions'
}
